<script lang="ts">
  import { link } from "svelte-spa-router";
  import { requestReset, ApiError } from "../lib/api";
  import { _ } from "../lib/i18n";

  let email = "";
  let submitting = false;
  let done = false;
  let error: string | null = null;

  async function submit(e: Event) {
    e.preventDefault();
    error = null;
    if (!email) return;
    submitting = true;
    try {
      await requestReset({ email });
      done = true;
    } catch (err) {
      error = err instanceof ApiError ? err.message : "error";
    } finally {
      submitting = false;
    }
  }
</script>

<section class="login">
  <div class="card">
    <h1>{$_("reset.title")}</h1>
    {#if done}
      <p class="sub" data-testid="reset-sent">{$_("reset.sent")}</p>
      <a class="forgot" href="/" use:link data-testid="reset-back">{$_("account.back")}</a>
    {:else}
      <p class="sub">{$_("reset.help")}</p>
      <form on:submit={submit}>
        <label>
          {$_("reset.email")}
          <input
            type="email"
            autocomplete="username"
            bind:value={email}
            data-testid="reset-email"
            required
          />
        </label>
        <button type="submit" disabled={submitting} data-testid="reset-submit">
          {submitting ? $_("reset.sending") : $_("reset.send")}
        </button>
        {#if error}<p class="error" data-testid="reset-error">{error}</p>{/if}
      </form>
      <a class="forgot" href="/" use:link data-testid="reset-back">{$_("account.back")}</a>
    {/if}
  </div>
</section>

<style>
  .login {
    min-height: 100vh;
    display: grid;
    place-items: center;
    padding: 1rem;
    /* iOS viewport-fit=cover: keep the card out from under the status bar and
       home indicator. env() is 0 elsewhere, so 1rem is preserved. */
    padding-top: max(1rem, env(safe-area-inset-top));
    padding-bottom: max(1rem, env(safe-area-inset-bottom));
  }
  .card {
    width: 100%;
    max-width: 360px;
    background: #111827;
    border: 1px solid #374151;
    border-radius: 12px;
    padding: 1.5rem;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  }
  h1 {
    margin: 0 0 0.25rem;
    font-size: 1.5rem;
  }
  .sub {
    margin: 0 0 1rem;
    color: #9ca3af;
  }
  form {
    display: grid;
    gap: 0.75rem;
    margin-bottom: 1rem;
  }
  label {
    display: grid;
    gap: 0.25rem;
    font-size: 0.875rem;
    color: #d1d5db;
  }
  input {
    padding: 0.6rem 0.75rem;
    background: #1f2937;
    color: #f3f4f6;
    border: 1px solid #374151;
    border-radius: 8px;
    font-size: 1rem;
  }
  button {
    padding: 0.6rem 0.75rem;
    background: #10b981;
    color: #04221a;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
  }
  .error {
    margin: 0;
    color: #fca5a5;
    font-size: 0.875rem;
  }
  .forgot {
    display: inline-block;
    color: #6ee7b7;
    font-size: 0.85rem;
    text-decoration: none;
  }
  .forgot:hover {
    text-decoration: underline;
  }
</style>
